import createIcon from './createIcon';

export default createIcon(require('./facebook.svg'));